import Vue from "vue";
import Router from "vue-router";

import store from "@/store";

import Mall from "@/pages/client/Mall";
import MallShow from "@/pages/client/MallShow";
import MallIndex from "@/pages/client/MallIndex";
import MallLogin from "@/pages/client/MallLogin";
import GoodsDetail from "@/pages/client/GoodsDetail";
import GoodsList from "@/pages/client/GoodsList";
import Personal from "@/pages/client/Personal";
import MyOrder from "@/pages/client/MyOrder";
import Shelves from "@/pages/client/Shelves";
import Purchase from "@/pages/client/Purchase";
import OrderDetail from "@/pages/client/OrderDetail"; // 订单详情
import MyAddress from "@/pages/client/MyAddress"; // 收货地址
import ChangePwd from "@/pages/client/ChangePwd"; // 修改密码
import ReturnGoods from "@/pages/client/ReturnGoods"; //退货申请
import Barter from "@/pages/client/Barter"; //换货申请
import Repair from "@/pages/client/Repair"; //维修申请
import ExtraStandard from "@/pages/client/ExtraStandard"; //标外维修
import CreateOrder from "@/pages/client/CreateOrder"; //标外维修
import CommodityApplication from "@/pages/client/CommodityApplication"; //标外商品申请
import Satisfaction from "@/pages/client/Satisfaction"; //标外商品申请
import Wechat from "@/pages/client/Wechat"; //标外商品申请
import MyData from "@/pages/client/MyData";
import Cart from "@/pages/client/Cart";
import RegularPurchaseList from "@/pages/client/RegularPurchaseList";
import ErrorPage from "@/pages/ErrorPage";
import { format } from "crypto-js";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/mall",
    },
    {
      path: "/login",
      name: "MallLogin",
      component: MallLogin,
    },
    {
      path: "/mall",
      name: "Mall",
      component: Mall,
      redirect: "/mall/show",
      children: [
        {
          path: "show",
          name: "MallShow",
          component: MallShow,
          redirect: "/mall/show/index",
          children: [
            {
              path: "index",
              name: "MallIndex",
              component: MallIndex,
              meta: {
                requireLogin: false,
              },
            },
            {
              path: "goodsList/:typeId/:keyword",
              name: "GoodsList",
              component: GoodsList,
              meta: {
                requireLogin: true,
              },
            },
          ],
        },
        {
          path: "goods/:id",
          name: "GoodsDetail",
          component: GoodsDetail,
          meta: {
            requireLogin: true,
          },
        },
        {
          path: "cart",
          name: "Cart",
          component: Cart,
          meta: {
            requireLogin: true,
          },
        },
        {
          path: "regularPurchaseList",
          name: "RegularPurchaseList",
          component: RegularPurchaseList,
          meta: {
            requireLogin: true,
          },
        },
        {
          path: "createOrder",
          name: "CreateOrder",
          component: CreateOrder,
          meta: {
            requireLogin: true,
          },
        },
        {
          path: "orderDetail/:id",
          name: "OrderDetail",
          component: OrderDetail,
          meta: {
            requireLogin: true,
          },
        },
        {
          path: "personal",
          name: "Personal",
          component: Personal,
          redirect: "/mall/personal/cart",
          children: [
            {
              path: "myData",
              name: "MyData",
              component: MyData,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "myOrder",
              name: "MyOrder",
              component: MyOrder,
              meta: {
                requireLogin: true,
                keepAlive: true,
              },
            },
            {
              path: "Purchase",
              name: "Purchase",
              component: Purchase,
              meta: {
                requireLogin: true,
                keepAlive: true,
              },
            },
            {
              path: "Shelves",
              name: "Shelves",
              component: Shelves,
              meta: {
                requireLogin: true,
                keepAlive: true,
              },
            },
            {
              path: "myAddress",
              name: "MyAddress",
              component: MyAddress,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "changePwd",
              name: "ChangePwd",
              component: ChangePwd,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "returnGoods",
              name: "ReturnGoods",
              component: ReturnGoods,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "barter",
              name: "Barter",
              component: Barter,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "repair",
              name: "Repair",
              component: Repair,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "extraStandard",
              name: "ExtraStandard",
              component: ExtraStandard,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "commodityApplication",
              name: "CommodityApplication",
              component: CommodityApplication,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "satisfaction",
              name: "Satisfaction",
              component: Satisfaction,
              meta: {
                requireLogin: true,
              },
            },
            {
              path: "wechat",
              name: "Wechat",
              component: Wechat,
              meta: {
                requireLogin: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: "*",
      name: "ErrorPage",
      component: ErrorPage,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

//登录拦截
const cacheBackFrom = ["GoodsDetail"]; // 从这些页面返回时不刷新 page-a
router.beforeEach((to, from, next) => {
  console.log(to.name, from.name);
  if (['GoodsDetail', 'MyOrder'].includes(to.name)) {
    from.meta.keepAlive = true
    from.meta._keepKey = 'MyOrder-static' // same key = keep cached
  } else {
    from.meta.keepAlive = false
    from.meta._keepKey = 'MyOrder-' + Date.now() // new key = force refresh
  }
  if (to.meta.requireLogin) {
    if (store.state.clientToken) {
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/client.js